import { render, staticRenderFns } from "./Subconta.vue?vue&type=template&id=e681450a&"
import script from "./Subconta.vue?vue&type=script&lang=js&"
export * from "./Subconta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports